import React from 'react';

export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-line-chart-line',
      title: 'Lifestyle Tracking',
      description: 'Monitor your daily habits, sleep patterns, exercise routines, and environmental factors that affect oxygen levels.',
      image: 'Modern smartphone displaying health tracking dashboard with clean interface, lifestyle monitoring charts, oxygen level indicators, daily habit tracking, sleep and exercise data visualization, teal and white color scheme, minimalist health app design'
    },
    {
      icon: 'ri-guide-line',
      title: 'Habit Guidance',
      description: 'Receive personalized recommendations for breathing exercises, dietary changes, and lifestyle modifications.',
      image: 'Mobile app interface showing personalized health recommendations, breathing exercise guides, habit formation tools, progress tracking screens, motivational coaching features, clean modern design with teal accents'
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'Escalation Cues',
      description: 'Smart alerts and recommendations when your oxygen health indicators suggest professional medical consultation.',
      image: 'Health app notification system showing smart alerts, medical consultation reminders, escalation warnings, professional referral interface, emergency contact features, user-friendly medical guidance design'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Privacy-Focused',
      description: 'Your health data stays secure with end-to-end encryption and no sharing with third parties without consent.',
      image: 'Privacy-focused mobile app interface showing security features, encrypted data protection, user consent controls, privacy settings dashboard, secure health data management, trust and safety design elements'
    }
  ];

  return (
    <section className="py-20 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#111111] mb-6">
            Powerful Features for
            <br />
            <span className="text-[#12B6B6]">Complete Oxygen Health</span>
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Everything you need to monitor, improve, and maintain optimal oxygen levels in one intelligent app.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          {features.map((feature, index) => (
            <div key={index} className={`flex items-center gap-8 ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
              {/* Content */}
              <div className="flex-1 space-y-6">
                <div className="w-16 h-16 bg-[#12B6B6] rounded-2xl flex items-center justify-center">
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
                
                <div>
                  <h3 className="text-2xl font-bold text-[#111111] mb-4">{feature.title}</h3>
                  <p className="text-lg text-gray-700 leading-relaxed">{feature.description}</p>
                </div>
              </div>

              {/* Phone Mockup */}
              <div className="flex-1">
                <div className="relative mx-auto w-64 h-[450px]">
                  <div className="absolute inset-0 bg-gray-900 rounded-[2.5rem] p-2">
                    <div className="w-full h-full bg-white rounded-[2rem] overflow-hidden relative">
                      {/* Notch */}
                      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-24 h-5 bg-gray-900 rounded-b-lg z-10"></div>
                      
                      {/* Screen Content */}
                      <div 
                        className="w-full h-full relative"
                        style={{
                          backgroundImage: `url('https://static.readdy.ai/image/9842b5143901a0019f067b22648287f2/e02ccdad9401b4ae7d91a47c24564639.png')`,
                          backgroundSize: 'contain',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                        }}
                      >
                        <div className="absolute inset-0 bg-white/80 flex flex-col justify-center items-center p-6 text-center">
                          <div className="w-12 h-12 bg-[#12B6B6] rounded-xl flex items-center justify-center mb-4">
                            <i className={`${feature.icon} text-lg text-white`}></i>
                          </div>
                          <h4 className="text-sm font-bold text-[#111111] mb-2">{feature.title}</h4>
                          <div className="w-full bg-gray-200 rounded-full h-1 mb-4">
                            <div className="bg-[#12B6B6] h-1 rounded-full" style={{ width: `${75 + index * 5}%` }}></div>
                          </div>
                          <p className="text-xs text-gray-500">Feature Preview</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
